import { Service, Inject } from 'vue-di-container';
import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { ProviderModel } from './ProviderSupportModel';

@Service()
export default class ProviderService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async Get(
        name: string, enterpriseUnifiedNumber: string, accreditationNumber: string, taxNumber: string,
        pageIndex: string, pageSize: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/providers?Name=' + name
                + '&EnterpriseUnifiedNumber=' + enterpriseUnifiedNumber
                + '&AccreditationNumber=' + accreditationNumber
                + '&TaxNumber=' + taxNumber
                + '&pageIndex=' + pageIndex
                + '&pageSize=' + pageSize;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return [];
        }
    }

    public async Put(model: ProviderModel): Promise<any> {
        this.loaderService.ShowLoader();
        const request = {
            id: model.id,
            name: model.name,
            enterpriseUnifiedNumber: model.enterpriseUnifiedNumber,
            accreditationNumber: model.accreditationNumber,
            taxNumber: model.taxNumber,
            integrationApiKey: model.integrationApiKey,
            providerAttachmentModel: (model.providerAttachmentModel || []).map(a => ({
                id: (a as any).id || undefined,
                fileName: a.fileName,
                fileContent: a.fileContent,
                attachmentType: a.attachmentType
            })),
              providerRequestId: (model as any).providerRequestId || model.providerRequestId,
        };
        try {
            const url = window.$config.HostName + 'api/providers/support';
            const result = await this.axiosService.axiosInstance.put(url, request);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async GetById(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/providers/getattachment/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data.result;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
}
